var styles = {"icon":"navkit__Icon__icon"};

export { styles as default };
